export default "__VITE_ASSET__7GnVPSD8__ 1920w";